import { Ticker } from './Chrono/Types';
import { KeyboardInit, KeyboardPostUpdate } from './Input';
import { WorldLoadGltf } from './World';
import { CameraInit, CameraUpdate } from './Camera';
import GUI from 'lil-gui';
import { DebugGuiAddFolder, DebugInit } from './Debug';
import { LightAmbientGet, LightAmbientInit } from './Light';
import { OverlayAdd, OverlayInit, OverlayLoadAssets, OverlayTexture } from './Overlay';
import { Sprite, Texture as PixiTexture } from 'pixi.js';
import { ActorInit, ActorUpdate } from './Actor';
import { SpriteInit, SpriteUpdate } from './Sprite';
import { UpdateSetCallback, UpdateStart } from './Update';
import { RenderInit, RenderStart } from './Render';
import { CanvasInit } from './Canvas';
import { SceneFindMesh, SceneGet, SceneInit } from './Scene';

(async function() {
    CanvasInit();
    SceneInit();
    CameraInit();
    RenderInit();
    ActorInit();
    SpriteInit();
    LightAmbientInit(0xFFFFFF, 2);
    KeyboardInit();
    DebugInit();

    DebugGuiAddFolder('Ambient Light', (folder: GUI): void => {
        folder.add(LightAmbientGet(), 'intensity', 0.25, 4, 0.25);
    });

    await WorldLoadGltf('/hexen.glb');
    await OverlayInit();
    await OverlayLoadAssets();

    let scale = 4;
    let sprite = new Sprite({
        anchor: 0.5,
        texture: PixiTexture.from(OverlayTexture.Weapon.SapphireWand),
    });

    sprite.x = window.innerWidth / 2;
    sprite.y = window.innerHeight - ((sprite.height / 2) * scale);
    sprite.scale = scale;

    console.log(SceneFindMesh('Ettin'));

    OverlayAdd(sprite);
    RenderStart();
    UpdateStart();

    UpdateSetCallback((ticker: Ticker): void => {
        CameraUpdate(ticker);
        ActorUpdate(ticker);
        SpriteUpdate(ticker);
        KeyboardPostUpdate();
    });
})();
